import heroBus from "./assets/hero-bus.webp";
import aboutBus from "./assets/about-bus.webp";
import logo from "./assets/logo.webp";
import gTrip from "./assets/gallery/trip.webp";
import gService from "./assets/gallery/service.webp";
import gComfort from "./assets/gallery/bus-comfort.webp";
import gFleet from "./assets/gallery/fleet.webp";
import gTour from "./assets/gallery/tour.webp";
import gGrey from "./assets/gallery/grey-bus.webp";
import gInterior from "./assets/gallery/bus-interior.webp";
import gEvent from "./assets/gallery/event.webp";
import gPassengers from "./assets/gallery/passengers.webp";
import gView from "./assets/gallery/bus-view.webp";
import gQuarry from "./assets/gallery/quarry.webp";

export type Lang = "he" | "en";
export type Theme = "dark" | "light";

export const images = { heroBus, aboutBus, logo };

/* Gallery order preserved from the original build. */
export const galleryImages = [
  gTrip, heroBus, gService, gComfort, gFleet, gTour,
  gGrey, gInterior, gEvent, gPassengers, gView, gQuarry,
];

export const contactDetails = {
  phone: { display: "08-8667777", href: "tel:088667777" },
  whatsapp: { display: "050-8323032", href: "https://wa.me/972508323032" },
  email: "office@sty-travel.com",
};

export const translations = {
  he: {
    nav: { about: "אודות", services: "שירותים", gallery: "גלריה", contact: "צור קשר" },
    hero: {
      title: "S.T.Y. Travel LTD.",
      subtitle: "תחבורה ואמינות מעל הכל.",
      cta: "צור קשר",
    },
    about: {
      title: "אודות החברה",
      text: "חברת S.T.Y. Travel LTD הינה חברת הסעות מובילה המספקת שירותי תחבורה אמינים, בטוחים ונוחים. עם צי רכבים חדיש ונהגים מקצועיים, אנו מתחייבים לחוויית נסיעה ברמה הגבוהה ביותר. אנו שמים דגש על בטיחות, דיוק בזמנים ושירות אדיב לכל לקוח.",
    },
    services: {
      title: "השירותים שלנו",
      /* NOTE: the `text` lines are drafts - replace with your own wording. */
      items: [
        {
          title: "שירותי הסעות",
          text: "הסעות מאורגנות לכל מטרה, עם צי רכבים חדיש ונהגים מקצועיים.",
        },
        {
          title: "הסעת עובדים",
          text: "הסעות קבועות לעובדים אל מקום העבודה וממנו, במסלולים ובזמנים קבועים.",
        },
        {
          title: "הסעות תלמידים",
          text: "הסעות לתלמידים אל מוסדות החינוך ובחזרה, בליווי נהגים מנוסים.",
        },
        {
          title: "תיירות פנים",
          text: "טיולים ונסיעות מאורגנות ברחבי הארץ, לקבוצות בכל גודל.",
        },
        {
          title: "תיירות חוץ",
          text: "הסעות וטיולים מאורגנים ליעדים מחוץ לישראל.",
        },
        {
          title: "הסעות לאירועים וטיולים",
          text: "הסעות לאירועים, ימי גיבוש וטיולים, בהתאמה לצורכי הקבוצה.",
        },
      ],
    },
    features: {
      title: "למה לבחור בנו?",
      items: [
        "צי רכבים חדיש ומפואר",
        "אינטרנט אלחוטי חינם",
        "שירות מקצועי ואדיב",
        "זמינות 24/7",
      ],
    },
    gallery: { title: "גלריה", showAll: "הראה הכל", showLess: "הצג פחות" },
    reviews: { heading: "לקוחות ממליצים", subheading: "הסיפורים של הלקוחות שלנו" },
    contact: {
      title: "צור קשר",
      subtitle: "בחרו דרך שנוחה לכם ונשמח לעזור",
      phone: "טלפון",
      whatsapp: "וואטסאפ",
      email: "אימייל",
      callNow: "חייג",
      openWhatsapp: "שלח הודעה",
      sendEmail: "שלח מייל",
    },
    footer: { copy: "העתק", copied: "הועתק!", rights: "כל הזכויות שמורות" },
    cookies: {
      title: "הסכמה לשימוש בעוגיות",
      message:
        "אנחנו משתמשים בעוגיות כדי לשפר את חוויית הגלישה שלך באתר. בהמשך גלישה באתר אתה מסכים לשימוש בעוגיות בהתאם למדיניות הפרטיות שלנו.",
      accept: "אני מסכים",
    },
    a11y: { title: "נגישות", fontSize: "גודל טקסט", contrast: "ניגודיות גבוהה", hidePhotos: "הסתר תמונות", reset: "אפס" },
  },
  en: {
    nav: { about: "About", services: "Services", gallery: "Gallery", contact: "Contact" },
    hero: {
      title: "S.T.Y. Travel LTD.",
      subtitle: "Reliability & Transportation Excellence",
      cta: "Contact Us",
    },
    about: {
      title: "About Us",
      text: "S.T.Y. Travel LTD is a leading transportation company providing reliable, safe, and comfortable transport services. With a modern fleet and professional drivers, we commit to the highest level of travel experience. We emphasize safety, punctuality, and courteous service for every client.",
    },
    services: {
      title: "Our Services",
      /* NOTE: the `text` lines are drafts - replace with your own wording. */
      items: [
        {
          title: "Transportation Services",
          text: "Organised transport for any purpose, with a modern fleet and professional drivers.",
        },
        {
          title: "Employee Shuttle",
          text: "Regular shuttles to and from the workplace, on fixed routes and schedules.",
        },
        {
          title: "Student Transport",
          text: "Transport for students to educational institutions and back, with experienced drivers.",
        },
        {
          title: "Domestic Tourism",
          text: "Organised tours and trips across the country, for groups of any size.",
        },
        {
          title: "International Tourism",
          text: "Organised transport and tours to destinations outside Israel.",
        },
        {
          title: "Events & Trips",
          text: "Transport for events, team days and trips, tailored to the group's needs.",
        },
      ],
    },
    features: {
      title: "Why Choose Us?",
      items: [
        "Modern Luxury Fleet",
        "Free WiFi on Board",
        "Professional Service",
        "24/7 Availability",
      ],
    },
    gallery: { title: "Gallery", showAll: "Show All Photos", showLess: "Show Less" },
    reviews: { heading: "Customer Reviews", subheading: "Stories from our clients" },
    contact: {
      title: "Contact Us",
      subtitle: "Choose the easiest way to reach us",
      phone: "Phone",
      whatsapp: "WhatsApp",
      email: "Email",
      callNow: "Call now",
      openWhatsapp: "Open WhatsApp",
      sendEmail: "Send Email",
    },
    footer: { copy: "Copy", copied: "Copied!", rights: "All rights reserved" },
    cookies: {
      title: "Cookie Consent",
      message:
        "We use cookies to improve your browsing experience on our website. By continuing to use this site, you agree to our use of cookies in accordance with our privacy policy.",
      accept: "I Accept",
    },
    a11y: { title: "Accessibility", fontSize: "Text size", contrast: "High contrast", hidePhotos: "Hide images", reset: "Reset" },
  },
} as const;

export const testimonials = [
  {
    id: "p1",
    name: "לקוח 1",
    rating: 5,
    content: `שתי נקודות לשימור מהסיור האחרון
האחד הנהג  היה מעולה , ממש כיף
ראשית האוטובוס הרבה יותר נוח ,כולל מרווח נוח לרגליים
ושנית ,הנהג האלוף  הכין  לנו פריסה בסיום המסלול 
כל הכבוד
חושב שכולנו נשמח שהוא ילווה אותנו בסיור האחרון ובאלה של שנה הבאה.`,
  },
  {
    id: "p2",
    name: "לקוח 2",
    rating: 5,
    content: `לתומר ולכל הצוות "אס.טי.וואי טרוול" 
בשישי האחרון  התקיים הסיור האחרון ,
אני מבקש להודות לכם על העבודה המצוינת שעשייתם למעננו במהלך השנה.
שנה שהייתה מאתגרת ורצופה בשינויים ובביטולים .
כרגיל תענוג לעבוד אתכם. אתם מקצוענים אמיתיים ונותנים שרות מעולה.`,
  },
  {
    id: "p3",
    name: "לקוח 3",
    rating: 5,
    content: `היי תומר,
היה כל כך מוצלח אתמול והרבה בזכות הנהגת המהממת!!!
רוצים אותה תמיד איתנו; באמת שאין עליה.
יומקסים`,
  },
  {
    id: "p4",
    name: "לקוח 4",
    rating: 5,
    content: `תומר היקר .. תודתי והערכתי על השירות המצוין שקיבלתי !
במיוחד אני רוצה להודות לנהג שדאג להעניק חוויה נעימה ומקצועית. הנכונות שלו לעזור, אדיבותו והסבלנות שגילה כלפי הנוסעים עשה את הנסיעה שלי להרבה יותר נעימה. 
שירות כזה הוא לא מובן מאליו מבחינתי - תודה על הכל!!!`,
  },
  {
    id: "p5",
    name: "לקוח 5",
    rating: 5,
    content: `היי , תודה על השירות המצוין והנסיעה הנעימה , הכל הלך חלק והנהג היה אדיב וסבלני .
תודה רבה לכם על הכל!`,
  },
];
